<script>
  import { clickOutside } from '@utils/clickOutside';
  import ListCommentsHeader from './ListCommentsHeader.svelte';
  import { onMount, onDestroy } from 'svelte';
  import Comments from '@app-components/comments/Comments.svelte';
  import jQuery from 'jquery';
  import { getCurrentUserStore } from '@stores/current_user';
  import CustomScroll from '@utils/custom-scroll';
  import AddComment from '@app-components/comments/AddComment.svelte';
  export let commentId = null;
  export let showModal = false;
  export let customGroupStore;
  export let addCommentPopEnabled = false;
  let currentUser = getCurrentUserStore('default');
  let focused = false;
  let clickedOutside = false;

  let group = customGroupStore;
  let unsubGroup = group.subscribe((x) => (group = x));
  let openCommentsInAddMode = false;
  $: total = (group && group.comments && group.comments.total) || 0;
  let isVisible = false;
  let isCommentEditMode = false;
  let hiddenCommentsClicked = false;
  let commentPopToggle = false;
  let commentPopActed = function () {
    commentPopToggle = true;
    jQuery('.bottom-bar').removeAttr('style');
    jQuery('.group-actions-container').removeAttr('style');
    showModal = true;
    focused = true;
    openCommentsInAddMode = true;
  };

  var setupModal = function (node) {
    jQuery('body').width(jQuery('body').width());
    jQuery('body').css('overflow', 'hidden');
    setTimeout(() => {
      jQuery(node).css('background', 'rgba(22, 13, 54, 0.5)');
    }, 600);
    return {
      destroy() {
        jQuery('body').removeAttr('style');
      },
    };
  };

  var setCorrectHeightDelay = function () {
    if (openCommentsInAddMode) {
      return;
    }
    jQuery('.group-actions-container').css('z-index', 50);
    jQuery('.bottom-bar').css('z-index', 50);

    return {
      destroy() {
        jQuery('.bottom-bar').removeAttr('style');
        jQuery('.group-actions-container').removeAttr('style');
      },
    };
  };

  var setCorrectHeight = function (node) {
    setTimeout(setCorrectHeightDelay, 0, node);
  };

  onDestroy(() => {
    unsubGroup();
  });

  onMount(() => {
    if (commentId != null) {
      setTimeout(CustomScroll.scrollToRequiredDivById, 200, `comment-box-${commentId}`);
      commentId = null;
    }

    setTimeout(() => {
      isVisible = true;
    }, 0); // Short delay to ensure DOM is ready
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .add-comment-container.focused {
    // z-index: 50;
    :global(.add-comment-body) {
      border: 1px solid #896bd9 !important;
      background: #f5f3fc !important;
    }
  }
  .add-comment-container {
    position: fixed;
    z-index: 21;
    bottom: 128px;
    left: 0px;
    width: 100%;
    border-bottom: 1px solid var(--neutral-input-gray, #ececec);
    background: #fff;
    box-shadow: 0px -18px 28px 0px rgba(0, 0, 0, 0.04);
    display: flex;
    height: 64px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    &.logged-out-user {
      bottom: 64px;
    }

    &.comments-visible {
      bottom: 66px;
      z-index: 51;
    }
    &.add-mode {
      z-index: 50;
      bottom: 0px;
    }
    &.modal-mode {
      z-index: 50;
      bottom: 64px;
    }
    :global(.add-comment-body) {
      border-radius: 8px !important;
      border: 1px solid var(--neutral-input-gray, #ececec) !important;
      background: var(--neutral-white, #fff) !important;
    }
    .user-icon {
      width: 32px;
      height: 32px;
    }
    .comment-container {
      display: flex;
      flex-direction: row;
      padding: 12px 16px;
      width: calc(100% - 40px);
      justify-content: space-between;
      align-items: center;
      border-radius: 8px;
      border: 1px solid var(--neutral-input-gray, #ececec);
      background: var(--neutral-white, #fff);
      .comment-text {
        color: var(--neutral-gray-light, #b3b3b3);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        cursor: pointer;
      }
      .emojis-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        .emoji-icon {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }
      }
    }
  }

  .group-comments-container {
    background: var(--neutral-white, #fff);
    max-height: calc(90dvh - 192px);
    width: 100%;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    box-shadow: 0px -5px 26px 0px rgba(0, 0, 0, 0.08);
    padding: 20px;
    &.empty {
      padding: 10px;
    }

    &.add-mode {
      // max-height: calc(50dvh - 128px);
      bottom: 68px;
      .comments-listing-container {
        max-height: calc(50dvh - 116px);
        padding-bottom: 10px;
      }
    }
    .comments-listing-container {
      padding-right: 10px;
      margin-right: -10px;
      padding-bottom: 98px;
      max-height: calc(90dvh - 244px);
    }
    .empty-comments-container {
      height: 108px;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #808080;
      .message {
        color: var(--purple-text-purple, #5e518e);
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
      }
    }
  }
  .parent-comments-container {
    position: fixed;
    bottom: -500px;
    left: 0px;
    transition: bottom 0.35s ease-out;

    width: 100%;
    &.visible {
      bottom: 128px;
    }
    &.add-mode {
      bottom: 64px;
    }
    // bottom: 192px;
  }

  * :global(.comment-input) {
    width: 100% !important;
  }
</style>

{#if showModal}
  <div
    use:setupModal
    style="left: 0px; right: unset; top: unset; background: none;"
    class="backdrop outer-container"
    on:click={() => {
      if (clickedOutside) {
        showModal = false;
        openCommentsInAddMode = false;
      }
      clickedOutside = false;
    }}>
    {#if isCommentEditMode}
      <div class="add-comment-edit-mode-overlay"></div>
    {/if}
    <div
      class="parent-comments-container"
      use:setCorrectHeight
      class:add-mode={openCommentsInAddMode}
      class:visible={isVisible}
      use:clickOutside
      on:click={() => {
        focused = false;
      }}
      on:click_outside={() => {
        if (isCommentEditMode) {
          return;
        }
        if (commentPopToggle) {
          commentPopToggle = false;
          return;
        }
        clickedOutside = true;
      }}>
      <div class:empty={total == 0} class="group-comments-container {openCommentsInAddMode ? 'add-mode' : 'read-mode'}">
        <ListCommentsHeader
          on:closed={() => {
            showModal = false;
            focused = false;
            openCommentsInAddMode = false;
          }}
          mobile={true}
          total={total} />
        {#if group.comments && group.comments.data.length > 0}
          <div class="purple-scrollbar-thin comments-listing-container" style="overflow-y: auto;">
            {#if group.show_comments}
              <Comments
                customGroupStore={customGroupStore}
                mobile={true}
                viewStyle="detail-view"
                on:commentsHidden={() => (hiddenCommentsClicked = true)} />
            {/if}
          </div>
        {/if}
        {#if total === 0 && !hiddenCommentsClicked}
          <div class="empty-comments-container">
            <div class="message">🥳 Be the first to comment!</div>
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}
<div
  class="add-comment-container"
  on:click={() => {
    commentPopActed();
  }}
  class:focused={focused}
  class:comments-visible={showModal && isVisible}
  class:add-mode={openCommentsInAddMode}
  class:logged-out-user={!currentUser || !currentUser.id}
  class:hidden={!showModal && !addCommentPopEnabled}>
  <div style="width: 100%; padding: 16px; border-radius: 0px;margin-top: 0px; background: #fff;">
    <AddComment
      on:focus={() => {
        commentPopActed();
      }}
      on:acted-upon={() => {
        commentPopActed();
      }}
      bind:editMode={isCommentEditMode}
      context={'list'}
      mobile={true}
      customGroupStore={customGroupStore} />
  </div>
</div>
